module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('f7-accordion-item', {
    staticClass: "accordionForm",
    attrs: {
      "expanded": _vm.open
    },
    on: {
      "accordion:open": function($event) {
        _vm.openedAccordion = true
      },
      "accordion:opened": function($event) {
        _vm.openedFinishedAccordion = true
      },
      "accordion:close": function($event) {
        _vm.openedAccordion = _vm.openedFinishedAccordion = false
      }
    }
  }, [_c('f7-accordion-toggle', {
    staticClass: "accordionToggle",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "col-sm-auto titleUnderline",
    class: [(_vm.isTitleUpperCase ? 'text-uppercase' : ''), (_vm.isTitleBold ? 'font-weight-bold' : '')]
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), (_vm.star) ? _c('span', {
    staticClass: "color-red"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), (_vm.openedAccordion) ? _c('i', {
    staticClass: "f7-icons formChevron",
    style: ({
      color: _vm.chevron_color
    })
  }, [_vm._v(_vm._s(_vm.chevron_open) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.openedAccordion) ? _c('i', {
    staticClass: "f7-icons formChevron",
    style: ({
      color: _vm.chevron_color
    })
  }, [_vm._v(_vm._s(_vm.chevron_close) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('f7-accordion-content', {
    class: {
      accordionContentExpended: _vm.openedFinishedAccordion
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46590bd7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46590bd7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormAccordion.vue
// module id = 2404
// module chunks = 2